/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from "./styles.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useGetInfo } from "../../../../hooks/useGetInfo";
import {
  BillIcon,
  CardPaymentV2Icon,
  CustomerIconV2,
  EndOfDayIcon,
  ExpenseIconV2,
  LogoutIcon,
  // OnlineOrderIcon,
  PendingIcon,
  ReconciliationIconV2,
  ReturnsIconV2,
  SalesIconV2,
  SectionOrderIconV2,
  SupportIconV2,
  // TerminalIcon,
  // TableIcon,
} from "../../../../assets/svgIcons";
import secondaryComponents from "../..";
import primaryComponents from "../../../primaryComponents";
import { isSellMode, logoutHandler } from "../../../../helpers";
import { pathConstants } from "../../../../routes/pathContants";
import { RoutedModal } from "../../../common";
import { RecievePaymentPrompt } from "../PaymentPrompt/RecievePaymentPrompt";
import { useState } from "react";
import SupportOption from "../../SupportModal";

export const MoreMenuNav = ({ isMoreMenu = false, closeModal = () => {} }) => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const [views, setViews] = useState({
    isPayment: false,
    isSupportModalOpen: false,
  });

  const handleNavigate = (action = () => {}) => {
    action();
    closeModal();
  };

  return (
    <>
      <section
        className={`${styles.moreMenuNav} ${isMoreMenu ? styles.moreMenu : ""}`}
      >
        <div className={styles.navigation}>
          {storeDetails?.support_raven_payment && (
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
            >
              <a
                className={`${styles.navigation__item} ${styles.dontShowOnDeskTop}`}
                onClick={() =>
                  setViews((prev) => ({ ...prev, isPayment: true }))
                }
              >
                <CardPaymentV2Icon width="60" />
                <span>Recieve Payments</span>
              </a>
            </secondaryComponents.NavigateWithPermission>
          )}

          {storeDetails?.allow_generate_bill && (
            <a
              className={`${styles.navigation__item} ${styles.dontShowOnDeskTop}`}
              onClick={() =>
                handleNavigate(() =>
                  navigate(
                    pathConstants.SELL_MODE_BILLS({
                      store_id,
                    }) + `?store_id=${store_id}&payment_method=bill`,
                  ),
                )
              }
            >
              <BillIcon width="60" />
              <span>Bills</span>
            </a>
          )}

          <a
            className={`${styles.navigation__item} ${styles.dontShowOnDeskTop}`}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.SELL_MODE_PENDING_CHECKOUT({
                    store_id,
                  }) + `?store_id=${store_id}&status=PENDING_CHECKOUT`,
                ),
              )
            }
          >
            <PendingIcon width="60" />
            <span>Pending</span>
          </a>

          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_generate_end_of_day"
            showOnLocalSetup={true}
          >
            <a
              className={`${styles.navigation__item} ${styles.dontShowOnDeskTop}`}
              onClick={() =>
                handleNavigate(() =>
                  navigate(
                    pathConstants.SELL_MODE_ENDOFDAY({
                      store_id,
                    }) + `?store_id=${store_id}`,
                  ),
                )
              }
            >
              <EndOfDayIcon width="60" />
              <span>End Of Day</span>
            </a>
          </secondaryComponents.NavigateWithPermission>

          <a
            className={`${styles.navigation__item} ${styles.dontShowOnDeskTop}`}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.SELL_MODE_SALES({
                    store_id,
                  }) + `?store_id=${store_id}`,
                ),
              )
            }
          >
            <SalesIconV2 width="60" />
            <span>Sales</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.SELL_MODE_SECTION_ORDERS({
                    store_id,
                  }),
                ),
              )
            }
          >
            <SectionOrderIconV2 width="60" />
            <span>Section Order</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.INVENTORY_RECONCILIATIONS({
                    store_id,
                    isSellMode: isSellMode(),
                  }) + `?store_id=${store_id}`,
                ),
              )
            }
          >
            <ReconciliationIconV2 width="60" />
            <span>Reconciliation</span>
          </a>
          {/* <a
            className={styles.navigation__item}
            onClick={() => resetView({ key: "isOpenStorefrontWidget" })}
          >
            <StoreWalletIconV2 width="60" />
            <span>Store Wallet</span>
          </a> */}
          <a
            className={styles.navigation__item}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.EXPENSES_LIST({
                    store_id,
                    isSellMode: isSellMode(),
                  }) + `?store_id=${store_id}`,
                ),
              )
            }
          >
            <ExpenseIconV2 width="60" />
            <span>Expenses</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.SELL_MODE_CUSTOMERS({
                    store_id,
                  }) + `?store_id=${store_id}`,
                ),
              )
            }
          >
            <CustomerIconV2 width="60" />
            <span>Customers</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() =>
              handleNavigate(() =>
                navigate(
                  pathConstants.SELL_MODE_RETURNS({
                    store_id,
                  }) + `?store_id=${store_id}`,
                ),
              )
            }
          >
            <ReturnsIconV2 width="60" />
            <span>Returns</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() =>
              setViews((prev) => ({ ...prev, isSupportModalOpen: true }))
            }
          >
            <SupportIconV2 width="60" />
            <span>Support</span>
          </a>
        </div>

        <div className={styles.moreMenuNav__bottom}>
          <primaryComponents.Button
            classNames={"ml-auto btn btn--danger"}
            style={{ borderRadius: 0, height: "60px", width: "45%" }}
            onClick={logoutHandler}
          >
            <LogoutIcon
              className="mr-1"
              width="20"
              height="20"
              strokeColor="white"
            />
            Log Out
          </primaryComponents.Button>
        </div>
      </section>

      <RoutedModal
        isActive={views?.isPayment}
        width={600}
        style={{ height: "auto" }}
        headerTitle="Collect Payments"
        headerDescription="Receive payment via transfer or card"
        closeModal={() => setViews((prev) => ({ ...prev, isPayment: false }))}
      >
        <RecievePaymentPrompt />
      </RoutedModal>

      <RoutedModal
        isActive={views.isSupportModalOpen}
        closeModal={() =>
          setViews((prev) => ({ ...prev, isSupportModalOpen: false }))
        }
        style={{ height: "auto" }}
        width="400px"
        headerTitle="Support"
      >
        <SupportOption />
      </RoutedModal>
    </>
  );
};
